<template>
    <div class="main-container">
        <v-container class="edit-panel overflow-auto pa-5">
            <v-form ref="form" @input="$emit('input', $event)">
                <!-- image info -->
                <v-row class="mt-0" dense>
                    <v-col cols="12">
                        <h4>{{ $t('titelbild') }}</h4>
                    </v-col>
                </v-row>
                <v-row v-if="imageRec" dense>
                    <v-col cols="12">
                        <v-img
                            :max-width="thumbImageConfig.width"
                            class="mt-3"
                            :src="getImageUrl(record, thumbImageConfig)"
                            :alt="thumbImageConfig.text"
                            :title="thumbImageConfig.text"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="imageRec" dense>
                    <v-col cols="12">
                        <!-- change img infos btn -->
                        <ActionBtn class="ma-1 justify-start" @click.stop="showSimpleDetailDlg = true">
                            <KpIcon icon-cls="pencil" color="white" disabled-color="grey" left />
                            {{ $t('edit_imginfos') }}
                        </ActionBtn>
                        <!-- crop img btn -->
                        <ActionBtn
                            class="ma-1 justify-start"
                            @click.stop="
                                initialImage = imageRec;
                                showImgCropDlgOnOpen = true;
                                imgSelectDlg = true;
                            "
                        >
                            <KpIcon icon-cls="pencil" color="white" disabled-color="grey" left />
                            {{ $t('change_titleimg') }}
                        </ActionBtn>
                    </v-col>
                </v-row>
                <v-row dense style="margin-top: 4px !important">
                    <v-col cols="12">
                        <!-- choose img btn -->
                        <ActionBtn
                            class="ma-1 justify-start"
                            @click.stop="
                                initialImage = null;
                                showImgCropDlgOnOpen = false;
                                imgSelectDlg = true;
                            "
                        >
                            <KpIcon icon-cls="mediamanager" color="white" disabled-color="grey" left />
                            {{ $t('choose_titleimg') }}
                        </ActionBtn>
                        <!-- delete img btn -->
                        <ActionBtn v-if="imageRec" class="ma-1 justify-start" @click.stop="deleteImg">
                            <KpIcon icon-cls="trash" color="white" disabled-color="grey" left />
                            {{ $t('delete_img') }}
                        </ActionBtn>
                    </v-col>
                </v-row>
                <!-- TODO: Freie Bilddatenbank -->
                <!-- free img database btn -->
                <!--
                <v-row dense>
                    <v-col cols="12">
                        <SecondaryBtn
                            width="200px"
                            class="ma-1 justify-start"
                            @click.stop="
                                initialImage = null;
                                showImgCropDlgOnOpen = false;
                                imgSelectDlg = true;
                            "
                        >
                            <KpIcon icon-cls="arrowrightup" color="primary" disabled-color="grey" left />
                            {{ $t('free_image_database') }}
                        </SecondaryBtn>
                    </v-col>
                </v-row>
                -->
                <v-row v-if="imageRec" class="mt-2" dense>
                    <v-col cols="12">
                        <label class="kp-label">{{ $t('dateiname') }}:</label>
                    </v-col>
                </v-row>
                <v-row v-if="imageRec" class="mt-n2" dense>
                    <v-col cols="12">
                        <span>{{ imageRec.orig_filename }}</span>
                    </v-col>
                </v-row>
                <v-row v-if="imageRec" class="mt-2" dense>
                    <v-col cols="12">
                        <label class="kp-label">{{ $t('titel_alt') }}:</label>
                    </v-col>
                </v-row>
                <v-row v-if="imageRec" class="mt-n2" dense>
                    <v-col cols="12">
                        <span>{{ imageRec.title || '-' }}</span>
                    </v-col>
                </v-row>
                <v-row v-if="imageRec" class="mt-2" dense>
                    <v-col cols="12">
                        <label class="kp-label">{{ $t('caption_alt') }}:</label>
                    </v-col>
                </v-row>
                <v-row v-if="imageRec" class="mt-n2" dense>
                    <v-col cols="12">
                        <span>{{ record.featured_image_caption || '-' }}</span>
                    </v-col>
                </v-row>
                <v-row v-if="imageRec" class="mt-2" dense>
                    <v-col cols="12">
                        <label class="kp-label">{{ $t('copyright') }}:</label>
                    </v-col>
                </v-row>

                <v-row v-if="imageRec" class="mt-n2" dense>
                    <v-col cols="12">
                        <span>&copy; {{ imageRec.credits || '-' }}</span>
                    </v-col>
                </v-row>

                <v-row v-if="!imageRec" dense>
                    <v-col cols="12" lg="8" xl="6">
                        <v-responsive :aspect-ratio="3 / 2">
                            <ImageUploadCard
                                width="100%"
                                height="100%"
                                :upload-params="{ event_organizer_id: record.organizer_id }"
                                @uploaded="afterImageUploaded"
                            />
                        </v-responsive>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <div class="info-panel overflow-auto pa-5">
            <!-- info -->
            <KpAlert type="info" style="max-width: 600px">
                <span v-html="$t('event_cover_image_requirements')" />
            </KpAlert>
        </div>
        <SimpleImgDetailDlg
            v-if="imageRec"
            v-model="showSimpleDetailDlg"
            :image-record="imageRec"
            @save="onImageEdit"
        />
        <MMSelectDialog
            v-if="imgSelectDlg"
            v-model="imgSelectDlg"
            :image-formats-config="imageConfig.event"
            :image-crop-data="record.featured_img_crop_config"
            :initial-image="initialImage"
            :initial-step="showImgCropDlgOnOpen ? 2 : 1"
            :organizer-id="userIsStaff() ? record.organizer_id : null"
            @image-select="onImageSelect"
            @image-crop="onImageCrop"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { errToStr } from '@/helpers/tools';
import { Event } from '@/models/Event';
import GlobalsMixin from '@/mixins/globals';
import ImageUploadCard from '@/components/ImageUploadCard.vue';
import SimpleImgDetailDlg from '@/components/event/SimpleImageDetailDlg';
import MMSelectDialog from '@/components/media_manager/SelectFormatDialog.vue';
import { userIsStaff } from '@/helpers/auth';
import { Image } from '@/models/Image';

export default {
    name: 'EventEditTitelbildSimple',
    components: {
        ImageUploadCard,
        SimpleImgDetailDlg,
        MMSelectDialog,
    },
    mixins: [GlobalsMixin],

    props: {
        record: {
            type: Event,
            required: true,
        },
    },

    data() {
        return {
            showImgCropDlgOnOpen: false,
            imgSelectDlg: false,
            initialImage: null,
            showSimpleDetailDlg: false,
            cacheBuster: new Date().getTime(),
        };
    },

    computed: {
        imageRec() {
            return this.$store.getters['image/imageById'](this.record.featured_image_id);
        },
    },

    watch: {
        record(record) {
            if (record && record.featured_image_id) {
                this.loadImage({ imageId: record.featured_image_id });
            }
        },
    },

    created() {
        // static view variables:
        this.imageConfig = this.globalVar('featured_images_config') || { event: {} };
        this.thumbImageConfig = this.imageConfig.event.thumb;
    },

    mounted() {
        this.loadImage({ imageId: this.record.featured_image_id });
        this.validateForm();
    },

    methods: {
        userIsStaff,
        ...mapActions('image', ['loadImage']),

        validateForm() {
            this.$refs.form.validate();
        },

        getImageUrl(eventRec, imageConf) {
            return `${this.globalVar('imageroot')}/event/${eventRec.id}/${imageConf.ident}.${imageConf.format}?ts=${
                this.cacheBuster
            }`;
        },

        async afterImageUploaded(images, flowFiles) {
            if (images && images.length) {
                const img = new Image(images[0]);
                await this.onImageCrop(null, img);
            }
        },

        async onImageSelect(image) {
            if (image) {
                await this.onImageCrop({}, image);
            }
        },

        async onImageCrop(cropData, image) {
            if (image) {
                try {
                    this.imgSelectDlg = false;
                    this.$emit('saving', true);
                    await this.createFeaturedImage(cropData, image, this.record);
                    if (this.record.featured_image_id !== image.id) {
                        this.record.set({
                            featured_image_caption: image.caption || null,
                        });
                    }
                    this.record.set({
                        featured_image_id: image.id,
                        featured_img_crop_config: cropData || null,
                    });
                    this.cacheBuster = new Date().getTime();
                    this.loadImage({ imageId: image.id });
                    this.$emit('featured-image-created');
                } catch (e) {
                    this.$toast({ message: errToStr(e), color: 'error' });
                } finally {
                    this.$emit('saving', false);
                }
            }
        },

        async createFeaturedImage(cropData, image, record) {
            await image.createFeaturedImage('event', cropData, record.id);
        },

        async deleteImg() {
            if (!this.record.featured_image_id) {
                return;
            }
            try {
                this.$emit('saving', true);
                this.record.set({
                    featured_image_id: null,
                    featured_image_caption: null,
                    featured_img_crop_config: null,
                });
                await this.record.save();
                this.cacheBuster = new Date().getTime();
                this.$emit('featured-image-created');
            } catch (e) {
                this.$toast({ message: errToStr(e), color: 'error' });
            } finally {
                this.$emit('saving', false);
            }
        },

        /**
         * After the user edited the image record's metadata,
         * we take the caption text and store it direcly on the event,
         * for de-coupling it from the original image.
         */
        async onImageEdit() {
            this.showSimpleDetailDlg = false;
            if (!this.record.featured_image_id) {
                return;
            }
            try {
                this.$emit('saving', true);
                this.record.set({
                    featured_image_caption: this.imageRec.caption,
                });
                await this.imageRec.save();
                await this.record.save();
                this.cacheBuster = new Date().getTime();
                this.$emit('featured-image-created');
            } catch (e) {
                this.$toast({ message: errToStr(e), color: 'error' });
            } finally {
                this.$emit('saving', false);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.main-container {
    display: grid;
    grid-template-areas: 'edit info';
    grid-template-rows: auto;
    grid-template-columns: minmax(440px, 800px) minmax(400px, 1fr);
    overflow: auto;
}
.edit-panel {
    grid-area: edit;
}
.info-panel {
    grid-area: info;
    background-color: var(--toolbar-bg-color);
}
.v-textarea :deep(textarea) {
    color: var(--gray-text-color);
}
</style>
